export * from './resume-current-mobile-day.module';
export * from './resume-current-mobile-day.component';
